<template>
  <div class="sort-by">
    <div class="flex flex-wrap w-full">
      <div class="spacer-x-1 sort-by__label">
        <p>Sort By:</p>
      </div>
      <div class="flex-shrink-0 sort-by__dropdown">
        <div class="dropdown">
          <button class="btn btn-block btn-default dropdown-toggle w-full" type="button" id="billboard-sort-by" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            {{ sortAndOrderBy.label }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="billboard-sort-by">
            <li v-for="(option, index) in computedOptions" :key="index" @click="trackSortApply">
              <router-link
                :to="{ query: routerLinkQueryForOption(option) }"
                @click.native="sortAndOrderBy = option">
                {{ option.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find, assign } from 'lodash'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],
  props: {
    setFilterMutation: {
      required: true,
      type: Function
    },
    filters: {
      required: true,
      type: Object
    },
    options: {
      required: false,
      type: Array
    }
  },

  computed: {
    sortAndOrderBy: {
      get () {
        return find(this.computedOptions, (option) => {
          return option.sort === this.filters.sort &&
            option.order === this.filters.order
        })
      },

      set ({ sort, order }) {
        this.setFilterMutation({ filter: 'sort', value: sort })
        this.setFilterMutation({ filter: 'order', value: order })
      }
    },

    computedOptions () {
      if (this.options) {
        return this.options
      }

      let sortOptions = [
        {
          label: 'Soonest Event Date',
          sort: 'date',
          order: 'asc'
        },
        {
          label: 'Furthest Event Date',
          sort: 'date',
          order: 'desc'
        },
        {
          label: this.monetaryCurrency ? 'Lowest Price' : 'Lowest Points',
          sort: 'price',
          order: 'asc'
        },
        {
          label: this.monetaryCurrency ? 'Highest Price' : 'Highest Points',
          sort: 'price',
          order: 'desc'
        }
      ]
      if (this.$userIsAdmin) {
        sortOptions = sortOptions.concat([
          {
            label: 'Most Recent Creation Date',
            sort: 'created_at',
            order: 'desc'
          },
          {
            label: 'Most Recent Completed Date',
            sort: 'completed_date',
            order: 'desc'
          },
          {
            label: 'Most Recent Booked Date',
            sort: 'scheduled_date',
            order: 'desc'
          },
          {
            label: 'Recently Contacted',
            sort: 'notes.created_at',
            order: 'desc'
          },
          {
            label: 'Least Recently Contacted',
            sort: 'notes.created_at',
            order: 'asc'
          },
          {
            label: 'Most Recently Modified',
            sort: 'updated_at',
            order: 'desc'
          },
          {
            label: 'Least Recently Modified',
            sort: 'updated_at',
            order: 'asc'
          }
        ])
      }
      if (this.$userIsAdmin && !this.$vlastMode) {
        sortOptions = sortOptions.concat([
          {
            label: 'Highest Probability',
            sort: 'probability',
            order: 'desc'
          },
          {
            label: 'Lowest Probability',
            sort: 'probability',
            order: 'asc'
          }
        ])
        sortOptions = sortOptions.concat([
          {
            label: 'Soonest Est Close Date',
            sort: 'est_close_date',
            order: 'asc'
          },
          {
            label: 'Furthest Est Close Date',
            sort: 'est_close_date',
            order: 'desc'
          }
        ])
      }
      return sortOptions
    }
  },

  methods: {
    routerLinkQueryForOption (option) {
      return assign({}, this.$route.query, {
        sort: option.sort,
        order: option.order
      })
    },

    trackSortApply () {
      // const sortOptionApplied = this.filters.sort + '-' + this.filters.order
      // const filterFields = []
      // let countApplied = 0
      // Object.keys(this.filters).forEach(key => {
      //   if (key !== 'sort' && key !== 'keywords' && key !== 'order') {
      //     filterFields.push({
      //       fieldName: key,
      //       fieldValue: this.filters[key]
      //     })
      //     if (this.filters[key] !== null && this.filters[key] !== []) {
      //       if (Array.isArray(this.filters[key])) {
      //         if (this.filters[key].length > 0) {
      //           countApplied++
      //         }
      //       } else {
      //         countApplied++
      //       }
      //     }
      //   }
      // })
      // const searchFields = [{
      //   fieldName: 'keywords',
      //   fieldValue: this.filters.keywords
      // }]
      // const pageName = this.$route.name
      // this.trackEvent(this.analytics.V2.JobsSortApplyEvent, { pageName, searchFields, filterFields, sortOptionApplied, countApplied })
    }
  }
}
</script>
